import { MouseEvent } from 'react';
import { NavigateFunction } from 'react-router';
import { hasTextSelection } from './has-text-selection';

interface HandlePostCardClickParams {
  event: MouseEvent;
  linkToPost?: boolean;
  navigate: NavigateFunction;
  postPath: string;
}

export function handlePostCardClick({
  event,
  linkToPost,
  navigate,
  postPath,
}: HandlePostCardClickParams): void {
  const isSelecting = hasTextSelection();

  if (!isSelecting && linkToPost) {
    if (event.metaKey || event.ctrlKey) {
      // Cmd/Ctrl+click - open in new tab
      window.open(postPath, '_blank');
    } else {
      navigate(postPath);
    }
  } else if (isSelecting) {
    // Prevents navigation when selecting text
    event.preventDefault();
  }
}
